module.exports = __webpack_public_path__ + "media/assets/images/pq2-940a60aac0877970a5a0f39cea915196.svg";